import { useState } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import kalemonLevels6 from "../Assets/images/kalemon-levels6.png"
import kalemonLevels7 from "../Assets/images/kalemon-levels7.png"
import kalemonLevels8 from "../Assets/images/kalemon-levels8.png"
import kalemonLevels9 from "../Assets/images/kalemon-levels9.png"
import kalemonLevels10 from "../Assets/images/kalemon-levels10.png"
import kalemonLevels15 from "../Assets/images/Frame 98.png"
import imgTex from "../Assets/images/Group (15).png"
import { useTranslation } from 'react-i18next'
import duration from "../Assets/images/duration.png";
import format from "../Assets/images/format.png";
import level from "../Assets/images/levels.png";
import certification from "../Assets/images/certification.png";
import headerImg from "../Assets/images/Group 114.png"
import ProgramHighlights from '../Components/programHighlights/ProgramHighlights'
import WhatYouGetSection from '../Components/whatYouGetSection/WhatYouGetSection'
import whatYouGetImg from "../Assets/images/wul3.png"
import WhoThisProgramIsFor from '../Components/WhoThisProgramIsFor/WhoThisProgramIsFor'

import img26 from "../Assets/images/1.png";
import img27 from "../Assets/images/3.png";
import img28 from "../Assets/images/4.png";
import img29 from "../Assets/images/5.png";
import img30 from "../Assets/images/11.png";
import { Modal } from 'antd'
import RegistrationPopup from '../Components/registrationPopUp/RegistrationPopup'

const KalemonLevels = () => {

    const { t } = useTranslation();
    const [isModalOpen, setIsModalOpen] = useState(false);


    const cardsData = [
        { title: t("duration"), details: t("kalemon_levels_cardData.duration_details"), img: duration },
        { title: t("format"), details: t("kalemon_levels_cardData.format_details"), img: format },
        { title: t("level"), details: t("kalemon_levels_cardData.level_details"), img: level },
        { title: t("certification"), details: t("kalemon_levels_cardData.certification_details"), img: certification },
    ];

    const whatYouGetData = [
        { description: t("kalemon_levels_cardData.level_progression") },
        { description: t("kalemon_levels_cardData.checkpoints") },
        { description: t("kalemon_levels_cardData.interactive") },
        { description: t("kalemon_levels_cardData.skills") },
        { description: t("kalemon_levels_cardData.grammar") },
    ]

    const whatProgramFor = [
        { img: img26, title: t("adults"), desc: t("adults_desc") },
        { img: img27, title: t("university_students"), desc: t("university_students_desc") },
        { img: img28, title: t("heritage_learners"), desc: t("heritage_learners_desc") },
        { img: img29, title: t("professional_learners"), desc: t("professional_learners_desc") },
        { img: img30, title: t("serious_students"), desc: t("serious_students_desc") },
    ];
    return (
        <div>
            <div className='kalemon-k12 kalemon-levels'>

                <section className='arabicLife-sec'>
                    <div className='first-section position-relative'>
                        <Row className='justify-content-start flex-column gx-0'>
                            <Col md={12} className='content-box'>
                                <Container>
                                    <h2 className='mb-3' style={{ marginTop: "150px" }}>{t("kalemon_levels")}</h2>
                                    <h5 className='mb-4'>
                                        {t("kalemon_levels_intro")}
                                    </h5>

                                </Container>
                            </Col>

                        </Row>
                        <Row className='justify-content-start flex-column '>
                            <Col md={12} className='green-div'>
                                <div className='ap-second-section d-flex justify-content-start px-5 align-items-center '>
                                    <Container>   <button className='btn fw-bold' onClick={() => setIsModalOpen(true)}>{t("start_now")}</button></Container>
                                </div>


                            </Col>

                        </Row>
                        <img src={headerImg} alt='' className='ar-life-logo' />
                    </div>
                </section>
                <section>
                    <Container>
                        <ProgramHighlights cardsData={cardsData} color='#FCE7524D' />
                        <WhatYouGetSection data={whatYouGetData} img={whatYouGetImg} />
                    </Container>
                </section>
                <section className='my-5'>
                    <WhoThisProgramIsFor data={whatProgramFor} />
                </section>
                <section className='my-5 k12-grade'>
                    <Container>
                        <h2 className='text-center '>{t("program_levels")}</h2>
                        <p className='text-center'>{t("program_levels_desc")}</p>
                    </Container>
                </section>
                <div className='seconed-section my-5'>

                    <div className='fourth-section'>
                        <Container>
                            <div className='relative-sec'>
                                <Row>
                                    <Col md={2} >
                                        <img src={kalemonLevels6} alt='' className='bookImage k12-books-items-position' style={{ position: "absolute", top: "-50px", width: "265px" }} />
                                    </Col>
                                    <Col md={9} className='d-flex align-items-start ' style={{ background: "white", padding: "60px 70px" }}>
                                        <img src={imgTex} alt='' />
                                        <div>
                                            <h6> {t("kalemon_level.intro_level_title")} </h6>
                                            <p> {t("kalemon_level.intro_level_desc")} </p>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className='relative-sec'>
                                <Row>
                                    <Col md={10} className='d-flex align-items-start ' style={{ background: "white", padding: "60px 70px" }}>
                                        <img src={imgTex} alt='' />
                                        <div>
                                            <h6> {t("kalemon_level.beginner_level_title")} </h6>
                                            <p> {t("kalemon_level.beginner_level_desc")} </p>
                                        </div>
                                    </Col>
                                    <Col md={2} >
                                        <img src={kalemonLevels7} alt='' className='bookImage k12-books-items-position2' style={{ position: "absolute", top: "-50px", width: "265px" }} />
                                    </Col>
                                </Row>
                            </div>
                            <div className='relative-sec'>
                                <Row>
                                    <Col md={2} >
                                        <img src={kalemonLevels8} alt='' className='bookImage k12-books-items-position' style={{ position: "absolute", top: "-50px", width: "265px" }} />
                                    </Col>
                                    <Col md={9} className='d-flex align-items-start ' style={{ background: "white", padding: "60px 70px" }}>
                                        <img src={imgTex} alt='' />
                                        <div>
                                            <h6> {t("kalemon_level.intermediate_level_title")} </h6>
                                            <p> {t("kalemon_level.intermediate_level_desc")} </p>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            <div className='relative-sec'>
                                <Row>
                                    <Col md={10} className='d-flex align-items-start ' style={{ background: "white", padding: "60px 70px" }}>
                                        <img src={imgTex} alt='' />
                                        <div>
                                            <h6> {t("kalemon_level.advanced_level_title")} </h6>
                                            <p> {t("kalemon_level.advanced_level_desc")} </p>
                                        </div>
                                    </Col>
                                    <Col md={2} >
                                        <img src={kalemonLevels9} alt='' className='bookImage k12-books-items-position2' style={{ position: "absolute", top: "-50px", width: "265px" }} />
                                    </Col>
                                </Row>
                            </div>
                            <div className='relative-sec'>
                                <Row>
                                    <Col md={2} >
                                        <img src={kalemonLevels10} alt='' className='bookImage k12-books-items-position' style={{ position: "absolute", top: "-50px", width: "265px" }} />
                                    </Col>
                                    <Col md={9} className='d-flex align-items-start ' style={{ background: "white", padding: "60px 70px" }}>
                                        <img src={imgTex} alt='' />
                                        <div>
                                            <h6> {t("kalemon_level.proficient_level_title")} </h6>
                                            <p> {t("kalemon_level.proficient_level_desc")} </p>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Container>
                    </div>

                    <div className='fifth-section last-sec'>
                        <Container>
                            <Row className='align-items-center'>
                                <Col md={7}>
                                    <h6>{t('kalemon_level.kalemon_levels_title')}</h6>
                                    <p className='text-start'>{t('kalemon_level.kalemon_levels_desc')}</p>
                                    <button onClick={() => setIsModalOpen(true)}>{t('kalemon_level.sign_up')}</button>
                                </Col>
                                <Col md={5}>
                                    <img src={kalemonLevels15} alt='' className='w-100' />
                                </Col>
                            </Row>

                        </Container>
                    </div>
                </div>

            </div>
            <Modal
                open={isModalOpen}
                footer={null}
                destroyOnClose
                onCancel={() => setIsModalOpen(false)} // close handler
                width={"80vw"}

            >
                <RegistrationPopup setIsModalOpen={setIsModalOpen} />
            </Modal>
        </div>
    )
}

export default KalemonLevels
